<section id="" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="startEndTimeForm" *ngIf="startEndTimeForm" (ngSubmit)="onSubmit()">
            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>START AND END TIME:</legend>
                    <div class="col-48 grid-element" >
                        <label>START TIME AND END TIME</label>
                        <div class="time-range">
                            <div>
                                <input type="time" formControlName="startTime">
                                <!-- <div style="color: red; font-size: small;">Obbligatorio</div> -->
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" formControlName="endTime">
                                <!-- <div style="color: red; font-size: small;">Obbligatorio</div> -->
                            </div>
                        </div>
                    </div>

                    <!--
                    <div class="grid-element-full">
                        <div class="signature-wrapper">
                            <h3 class="signature-title">Per favore firma qui sotto</h3>
                            <div class="signature-card">
                                <div class="sign">
                                    <signature-pad
                                    *ngIf="!delivery?.receiverSign"
                                    [options]="signaturePadOptions"
                                    (onEnd)="drawComplete()">
                                    </signature-pad>
                                    <img [src]="delivery?.receiverSign" alt="">
                                </div>
                                <div class="signature-actions">
                                    <button type="button" *ngIf="!delivery?.receiverSign" class="btn clear-btn" [disabled]="disabledBtn" (click)="clear()">Clear</button>
                                    <button type="button" *ngIf="delivery?.receiverSign" class="btn clear-btn" [disabled]="disabledBtn" (click)="deleteSignature()">Remove Sign</button>
                                    <button type="button" *ngIf="!delivery?.receiverSign" class="btn save-btn" [disabled]="disabledBtn" (click)="$event.preventDefault(); save();">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    -->
                </fieldset>
            </div>
            <div class="center mt-20">
                <button 
                    class="btn hvr-shrink center" 
                    (click)="$event.preventDefault(); onSubmit()"
                    [disabled]="btnDisabled || !startEndTimeForm.valid">
                    Salva
                    <i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>